import MobileDetect from 'mobile-detect';

const safariRegex = /^((?!chrome|android).)*safari/i;

function isSafari(): boolean {
  return safariRegex.test(window.navigator.userAgent);
}

function isTablet(): boolean {
  return !!new MobileDetect(window.navigator.userAgent).tablet();
}

function isMobile(): boolean {
  return !!new MobileDetect(window.navigator.userAgent).phone();
}

export function isMac(): boolean {
  return window.navigator.userAgent.indexOf('Macintosh') !== -1;
}

export function isMobileSafari(): boolean {
  return (isMobile() || isTablet()) && isSafari();
}

export function detectWebkitInAppBrowser() {
  const standalone = (navigator as any).standalone; // only webkit has this property
  const isSafari = /safari/i.test(navigator.userAgent); // all browsers on iOS report Safari in the userAgent
  return standalone === false && !isSafari;
}

export function iPhoneMachineId(): number | undefined {
  const match = /iPhone(\d+,\d+)/gi.exec(navigator.userAgent);
  if (match === null) return undefined;
  return parseFloat(match[1].replace(',', '.'));
}

// not supported on some iOS devices
export function setDifference<T>(a: Set<T>, b: Set<T>): Set<T> {
  const diff = new Set<T>();
  for (const it of a) if (!b.has(it)) diff.add(it);
  for (const it of b) if (!a.has(it)) diff.add(it);
  return diff;
}
